/**
 * Permission utilities
 * Helper functions for checking user permissions
 */

import { AuthService } from '../services/auth/AuthService';
import type { AdminAuthUser } from '../types/auth';

/**
 * Check if current user can manage admin users
 * Only super_admin role has this permission
 */
export const canManageAdminUsers = (): boolean => {
  const user = AuthService.getCurrentUser();
  const canManage = user?.role === 'super_admin';
  
  // Debug logging
  if (user) {
    console.log('canManageAdminUsers - User:', user.email, 'Role:', user.role, 'Can manage:', canManage);
  }
  
  return canManage;
};

/**
 * Check if current user has a specific role
 */
export const hasRole = (role: AdminAuthUser['role']): boolean => {
  const user = AuthService.getCurrentUser();
  return user?.role === role;
};

/**
 * Check if current user is super admin
 */
export const isSuperAdmin = (): boolean => {
  return hasRole('super_admin');
};

/**
 * Check if current user is support
 */
export const isSupport = (): boolean => {
  return hasRole('support');
};

